import { Auth } from 'aws-amplify'
Auth.configure({
  authenticationFlowType: 'CUSTOM_AUTH'
})

const LoginUserInformation = {
  install (Vue, options) {
    var loginUser = []
    Auth.currentAuthenticatedUser().then(current => {
      loginUser.username = current.username
      loginUser.user_name = current.attributes['custom:user_name']
      loginUser.role_id = current.attributes['custom:role_id']
      loginUser.customer_code = current.attributes['custom:customer_code']
    }, e => {})
    Vue.prototype.$loginuser = {
      set: async () => {
        var current = (await Auth.currentAuthenticatedUser())
        if (current != null) {
          loginUser.username = current.username
          loginUser.user_name = current.attributes['custom:user_name']
          loginUser.role_id = current.attributes['custom:role_id']
          loginUser.customer_code = current.attributes['custom:customer_code']
        }
      },
      get: (key) => {
        var result = ''
        result = loginUser[key]
        return result
      }
    }
  }
}
export default LoginUserInformation
